var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.50011H3.5C2.96957 5.50011 2.46086 5.71082 2.08579 6.08589C1.71071 6.46097 1.5 6.96967 1.5 7.50011V16.5001C1.5 17.0305 1.71071 17.5392 2.08579 17.9143C2.46086 18.2894 2.96957 18.5001 3.5 18.5001H12.5C13.0304 18.5001 13.5391 18.2894 13.9142 17.9143C14.2893 17.5392 14.5 17.0305 14.5 16.5001V15.5001M13.5 3.50011L16.5 6.50011M17.885 5.08511C18.2788 4.69126 18.5001 4.15709 18.5001 3.60011C18.5001 3.04312 18.2788 2.50895 17.885 2.11511C17.4912 1.72126 16.957 1.5 16.4 1.5C15.843 1.5 15.3088 1.72126 14.915 2.11511L6.5 10.5001V13.5001H9.5L17.885 5.08511Z",
    stroke: "#2191F0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconBlue);
export default __webpack_public_path__ + "static/media/edit-icon-blue.7b4e06b3b01720ad11f101ef160ce769.svg";
export { ForwardRef as ReactComponent };